import React from "react";
import PropTypes from "prop-types";
import {  Card } from "shards-react";

import { Grid, makeStyles } from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
    card: {
        padding: "20px"
    },

}));
const LoginLayout = ({ children }) => {
    const classes = useStyles()
    return (
        <Grid container style={{ height: "100vh" }} justify="center" alignItems="center">
            <Card className={classes.card}>
                {children}
            </Card>
        </Grid>
    );
}

LoginLayout.propTypes = {
    /**
     * Whether to display the navbar, or not.
     */
    noNavbar: PropTypes.bool,
    /**
     * Whether to display the footer, or not.
     */
    noFooter: PropTypes.bool
};

LoginLayout.defaultProps = {
    noNavbar: false,
    noFooter: false
};

export default LoginLayout;
